import {BoundTls} from './BoundTls';

import * as L from 'leaflet'
const Tls = {

    u: function (X, Y) {
        // UTM to AltLng
        BoundTls.getMinMaxBound().update(X, Y);
        return L.utm({ x: X, y: Y, zone: 39, band: 'S' }).latLng();
    },
    uNotSave: function (X, Y) {
        // UTM to AltLng 
        return L.utm({ x: X, y: Y, zone: 39, band: 'S' }).latLng();
    },

    u1: function (P) {
        // x,y as array to leaflet latLng
        return this.u(P[0], P[1]);
    },

    getBoundsPos: function (pos, b) {
        return [pos, [pos.lat + b, pos.lng + b]]
    },

    // getSvg: function () {
    //     var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    //     svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
    //     svgElement.setAttribute('viewBox', "0 0 200 200");
    //     svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
    //     return svgElement;
    // },

    str2path: function (str) {
        // var str ='298985.01710000,3797146.81140000;298984.78080000,3797146.73900000;298960.50770000,3797139.30590000';
        // return array of points
        var ffArr = str.split(';');
        var ll = [];
        for (var i = 0; i < ffArr.length; i++) {
            ffArr[i] = ffArr[i].split(',');
            if (ffArr[i].length == 2)
                ll.push(this.u(ffArr[i][0], ffArr[i][1]));
            // L.utm({x: ffArr[i][0], y: ffArr[i][1], zone: 39, band: 'S'}).latLng());
        }

        if (ll[0].lng < ll[1].lng) return ll;
        else return ll.reverse();
    },

    str2center: function (str) {
        // var str ='298985.01710000,3797146.81140000;298984.78080000,3797146.73900000;298960.50770000,3797139.30590000';
        return this.u1(this.str2centerInUTM(str));

    },

    str2centerInUTM: function (str) {
        // var str ='298985.01710000,3797146.81140000;298984.78080000,3797146.73900000;298960.50770000,3797139.30590000';
        let b = this.str2MinMax(str);
        return [(eval(b.maxX) + eval(b.minX)) / 2, (eval(b.maxY) + eval(b.minY)) / 2];
    },

    str2MinMax(str) {
        var ffArr = str.split(';');
        var minX = Infinity;
        var maxX = 0;
        var minY = Infinity;
        var maxY = 0;

        for (var i = 0; i < ffArr.length; i++) {
            ffArr[i] = ffArr[i].split(',');
            if (ffArr[i].length == 2) {
                if (ffArr[i][0] > maxX) maxX = ffArr[i][0];
                if (ffArr[i][1] > maxY) maxY = ffArr[i][1];
                if (ffArr[i][0] < minX) minX = ffArr[i][0];
                if (ffArr[i][1] < minY) minY = ffArr[i][1];
            }
        }
        return { minX, minY, maxX, maxY };
    },

    str2xyArr: function (str) {
        var ffArr = str.slice(0, -1).split(';');
        for (var i = 0; i < ffArr.length; i++) {
            ffArr[i] = ffArr[i].split(',');
            // if (ffArr[i].length == 2)
            //     ll.push([ffArr[i][0], ffArr[i][1]]);
        }
        return ffArr;
    },



    rectStr2angle: function (str) {
        var pxy = this.str2xyArr(str);
        var d1 = this.distanceAbs(pxy[0], pxy[1]);
        var d2 = this.distanceAbs(pxy[2], pxy[1]);
        var xy1;
        var xy2;
        if (d1 > d2) {
            xy1 = pxy[1];
            xy2 = pxy[0];
        } else {
            xy1 = pxy[2];
            xy2 = pxy[1];
        }

        return Math.atan((xy1[1] - xy2[1]) / (xy1[0] - xy2[0]));
    },
    d: function (p1, p2) {
        // difference of 2 x,y to x,y
        return [p1[0] - p2[0], p1[1] - p2[1]];
    },
    distanceAbs: function (xy1, xy2) {
        return Math.abs(xy1[0] - xy2[0]) + Math.abs(xy1[1] - xy2[1])

    },
    midPointXY(p1, p2) {
        // mid of 2 x,y to x,y
        return [(eval(p1[0]) + eval(p2[0])) / 2, (eval(p1[1]) + eval(p2[1])) / 2]
    }

    // get: function(mymap) {
    //     mymap.getBounds().getNorthEast().utm()
    // }

};

export {Tls}